<template>
  <div>
    <alertModal modalType="simple" :isModalShown="tipLogin"  :modalTitle="tipName" @cancel="isCancel" ></alertModal>
  </div> 
</template>

<script>
import { getExternalAccessTokenByKoUser } from '@/utils/api';
import cokeStorage, { checkNested } from '@/utils/utils';
import myAuth from '@/utils/auth';
import alertModal from '@/components/alertModal.vue';
import { setupLang } from '@/locales';
export default {
  name: 'KOToExternal',
  components: {
    alertModal,
  },
  data() {
    return {
      routId: '',
      tipLogin: false,
      tipName: '',
    };
  },
  created() {
    this.routId = this.$route.params.id;
    getExternalAccessTokenByKoUser(this.routId).then((res) => {
      if (res.data.status === "001") {
        if (checkNested(res, 'data', 'content', 'model')) {
          // console.log(res.data.content.model)
          cokeStorage.setItem('isExternal', true);
          const language = res.data.content.model.language === "zh-CN" ? 'zh' :'en';
          setupLang(language);
          // cokeStorage.setItem('access_token', res.data.content.model.accessToken)
          // cokeStorage.setItem('refresh_access_token', res.data.content.model.refreshAccessToken)
          myAuth.setLocalAccessToken(res.data.content.model);
          this.$router.push({ path: `/external/index/${this.routId}/1` });
        }
      } else {
        this.tipLogin = true;
        this.tipName = this.$t('NoPermissionForThisInvitation');
      }
    });
  },
  methods: {
    isCancel() {
      this.tipLogin = false;
      this.$router.push({ path: `/` });
    }
  }
};
</script>
